// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2H_8m","error":"Textarea_error__3h9JQ","readonly":"Textarea_readonly__1nMDZ","disabled":"Textarea_disabled__3WPs1"};